<template>
  <div>
    <import-page
      title="批量导入商品备案信息"
      :loading="loading"
      :templateUrl="templateUrl"
      :columns="columns"
      :isValid="isValid"
      :limit="1000"
      :previewList="previewList"
      :importLoading="importLoading"
      @on-import="importList"
      @on-preview="previewFile"
    >
    </import-page>
  </div>
</template>

<script>
import ImportPage from "@/components/import-page";
import goodsForRecordApi from "@/api/goodsForRecordApi";
import { CONST_IMPORT_DECLARE_GOODS_TEMPLATE_URL } from "@/config/constant";
import { isBarcodeValid } from "../../utils/barcode";
export default {
  data() {
    return {
      columns: [
        {
          title: "货主id",
          key: "customerId",
          width: 100,
          align: "center",
        },
        {
          title: "商品名称(中文)",
          key: "skuName",
          width: 200,
          align: "center",
        },
        {
          title: "商家货品编码",
          key: "outSkuId",
          width: 150,
          align: "center",
        },
        {
          title: "商品条码",
          key: "barcode",
          width: 100,
          align: "center",
        },
        {
          title: "备案序号",
          key: "itemRecordNo",
          width: 100,
          align: "center",
        },
        {
          title: "商品料号",
          key: "itemNo",
          width: 100,
          align: "center",
        },
        {
          title: "hscode",
          width: 100,
          key: "hsCode",
          align: "center",
        },
        {
          title: "商品规格",
          width: 200,
          key: "gmodel",
          align: "center",
        },
        {
          title: "申报计量单位",
          width: 200,
          key: "unit",
          align: "center",
        },
        {
          title: "法定计量单位",
          width: 200,
          key: "unit1",
          align: "center",
        },
        {
          title: "法定第二单位",
          width: 200,
          key: "unit2",
          align: "center",
        },
        {
          title: "原产国",
          width: 200,
          key: "countryCode",
          align: "center",
        },
        {
          title: "申报单价",
          width: 120,
          key: "declareUnitPrice",
          align: "center",
        },
        {
          title: "法定第一数量",
          width: 100,
          key: "unit1Value",
          align: "center",
        },
        {
          title: "法定第二数量",
          width: 100,
          key: "unit2Value",
          align: "center",
        },
        {
          title: "币值",
          width: 100,
          key: "currency",
          align: "center",
        },
        {
          title: "毛重",
          width: 150,
          key: "grossWeight",
          align: "center",
        },
        {
          title: "净重",
          width: 150,
          key: "netWeight",
          align: "center",
        },
        {
          title: "备注",
          width: 250,
          key: "remark",
          align: "center",
        },
        {
          width: 200,
          title: "提示信息",
          key: "warnMsg",
          align: "center",
          fixed: "right",
          render: (h, params) => {
            const msg = params.row.warnMsg;
            if (msg) {
              return <el-link type="warning">{msg}</el-link>;
            }
            return null;
          },
        },
        {
          title: "校验信息",
          key: "errorMsg",
          align: "center",
          fixed: "right",
          render: (h, params) => {
            const msg = params.row.errorMsg;
            return (
              <div>
                <el-tag type="success" v-show={!msg}>
                  校验成功
                </el-tag>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content={msg}
                  placement="top"
                  v-show={msg}
                >
                  <el-tag type="danger">校验失败</el-tag>
                </el-tooltip>
              </div>
            );
          },
        },
      ],
      loading: false,
      templateUrl: CONST_IMPORT_DECLARE_GOODS_TEMPLATE_URL,
      isValid: false,
      previewList: [],
      importLoading: false,
    };
  },
  components: {
    ImportPage,
  },
  methods: {
    previewFile(fileUrl) {
      if (!fileUrl) {
        this.$message({
          message: "请先上传文件",
          type: "error",
        });
        return;
      }
      if (!/.(xls|xlsx)$/.test(fileUrl)) {
        this.$message({
          message: "您上传的文件格式不正确",
          type: "error",
        });
        return;
      }
      this.loading = true;
      goodsForRecordApi
        .importPreview({
          fileUrl,
        })
        .then((res) => {
          this.previewList = res.value;
          const result = [];
          this.previewList.map((item) => {
            if (item.errorMsg) {
              result.push(item);
            }
            if (!isBarcodeValid(item.barcode)) {
              item.errorMsg = "条码不规范,请规范条码或者修改成【无】";
              result.push(item);
            }
          });

          this.isValid = result.length === 0;
          this.loading = false;
        });
    },
    importList() {
      this.importLoading = true;
      goodsForRecordApi
        .batchImport({
          request: JSON.stringify(this.previewList),
        })
        .then((res) => {
          this.importLoading = false;
          if (res.value) {
            this.$message.success("导入成功");
            this.$router.back();
          } else {
            this.$message.error("导入失败");
          }
        })
        .finally(() => {
          this.importLoading = false;
        });
    },
  },
};
</script>
